import { FormTextInput } from './FormTextInput'
import { TextInput, TextInputProps } from './TextInput'

export { FormTextInput, TextInput }
export type { TextInputProps }
